import { render, staticRenderFns } from "./HybridView.vue?vue&type=template&id=5056a6b2&scoped=true"
import script from "./HybridView.vue?vue&type=script&setup=true&lang=js"
export * from "./HybridView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HybridView.vue?vue&type=style&index=0&id=5056a6b2&prod&scoped=true&lang=css"
import style1 from "./HybridView.vue?vue&type=style&index=1&id=5056a6b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5056a6b2",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QSplitter from 'quasar/src/components/splitter/QSplitter.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTooltip,QMenu,QVirtualScroll,QItem,QItemSection,QList,QSplitter,QChip,QIcon});qInstall(component, 'directives', {ClosePopup});
